module.exports = __webpack_public_path__ + "franchise-anno-mobile.png";